export default {
  env: 'production',
  kibanaApi: 'https://api-support.xfinity.com/logger/',
};
